<template>
  <div id="app">
    <router-view :style="isWeixin ? 'border-top:none;' : 'border-top:50px solid #fff;'"></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isDetail: false,
      isWeixin:navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    };
  },
  created(){
    
  },
  methods:{
  }
};
</script>
<style lang="less" scoped>
#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //color: #2c3e50;
  width: 100vw;
  letter-spacing: 1px;
  position: relative;
  font-size: 14px;
  
}
</style>
